export { default as UpdateGlobalCompanyTabModalButton } from './UpdateGlobalCompanyTabModalButton';
